export default __webpack_public_path__ + "static/contact-email-5033a1a67128db6756f0ef3824ef7c83.png";